import { config, type SupportedCountry } from "@config";
import * as adapters from "./adapters";
import type { ICountryAdapter } from "../types";

export function getCountryAdapter(countryCode: string): ICountryAdapter {
  const normalizedCountryCode = countryCode.toLowerCase().trim();

  if (!config.supportedCountries.includes(normalizedCountryCode as any)) {
    throw new Error(`Unsupported country: ${countryCode}`);
  }

  switch (normalizedCountryCode as SupportedCountry) {
    case "us":
      return adapters.us;
    case "ca":
      return adapters.ca;
    case "nz":
      return adapters.nz;
  }
}
